(function () {
  var GOAL_FALLBACK = 100000;
  var questions = [
    {
      key: "uso",
      title: "O cabo vai servir para quê?",
      options: [
        ["casa", "Internet da casa", "Roteador, TV e computador do dia a dia."],
        ["trabalho", "Trabalho", "Escritório ou home office, com arquivo e videochamada."],
        ["jogo", "Jogos", "Menos travada do que no Wi-Fi."],
        ["rack", "Painel ou câmeras", "Vários equipamentos juntos, ou perto de muita fiação."]
      ]
    },
    {
      key: "aparelhos",
      title: "Quantos aparelhos usam a rede ao mesmo tempo?",
      options: [
        ["um", "Um aparelho", "Este cabo liga um aparelho só."],
        ["dois", "Dois aparelhos", "Dois pontos na mesma rede."],
        ["alguns", "Três ou quatro", "Computador, TV e celular na mesma rede."],
        ["muitos", "Cinco ou mais", "Switch, câmeras ou muitos pontos ligados juntos."]
      ]
    },
    {
      key: "velocidade",
      title: "Qual a velocidade da sua internet?",
      options: [
        ["100", "Até 100 mega", "O Cat5e dá conta dessa velocidade."],
        ["500", "De 100 a 500 mega", "O Cat5e continua sendo o ideal."],
        ["1000", "De 500 mega a 1 giga", "O Cat5e alcança até 1 giga."],
        ["mais", "Mais de 1 giga", "Aqui o ideal é o Cat6."]
      ]
    },
    {
      key: "tamanho",
      title: "Qual a distância até o ponto?",
      options: [
        ["0.5", "Até 50 cm", "O aparelho fica quase encostado."],
        ["1", "Cerca de 1 metro", "Do outro lado da mesa."],
        ["2.5", "Até 2,5 metros", "No mesmo cômodo."],
        ["5", "Cerca de 5 metros", "Em outro ponto do ambiente."],
        ["10", "Cerca de 10 metros", "Um trecho mais longo."],
        ["20", "Cerca de 20 metros", "De um lado ao outro do lugar."]
      ]
    },
    {
      key: "blindagem",
      title: "O cabo passa perto de fio de energia?",
      options: [
        ["nao", "Não", "O caminho fica longe de tomada e motor."],
        ["sim", "Sim", "Passa junto de fio elétrico ou muita fiação."]
      ]
    },
    {
      key: "prioridade",
      title: "O que importa mais neste cabo?",
      options: [
        ["durar", "Durar mais", "Fio 100% cobre, mais firme no uso de todo dia."],
        ["economia", "Gastar menos", "A opção mais em conta para esse uso e tamanho."]
      ]
    }
  ];

  var answers = {};
  var step = 0;

  function rootPath() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  }

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney && window.theme && theme.moneyFormat) {
      return Shopify.formatMoney(cents, theme.moneyFormat);
    }
    return (cents / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  }

  function priceLabel(value) {
    var number = Number(value);
    if (!isFinite(number)) return "";
    return number.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  }

  function esc(value) {
    return String(value == null ? "" : value).replace(/[&<>"']/g, function (char) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char];
    });
  }

  function qualifiedTotal(cart) {
    var total = 0;
    (cart.items || []).forEach(function (item) {
      var title = String(item.product_title || item.title || "").toLowerCase();
      var handle = String(item.handle || "").toLowerCase();
      if (title.indexOf("patch cord") !== -1 || handle.indexOf("patch-cord") !== -1) {
        total += item.original_line_price || item.final_line_price || item.line_price || 0;
      }
    });
    return total;
  }

  function paintGoal(cart) {
    document.querySelectorAll("[data-cpc-goal]").forEach(function (el) {
      var goal = Number(el.getAttribute("data-goal")) || GOAL_FALLBACK;
      var qualified = qualifiedTotal(cart);
      var remaining = Math.max(goal - qualified, 0);
      var percent = Math.min(Math.round((qualified / goal) * 100), 100);
      var fill = el.querySelector("[data-cpc-goal-fill]");
      var text = el.querySelector("[data-cpc-goal-text]");
      if (fill) fill.style.width = percent + "%";
      el.classList.toggle("is-complete", remaining === 0 && qualified > 0);
      el.setAttribute("aria-valuenow", String(percent));
      if (!text) return;
      if (remaining === 0 && qualified > 0) {
        text.textContent = "Você já ganhou R$ 100 de desconto. Ele entra sozinho nos patch cords.";
      } else if (qualified === 0) {
        text.textContent = "Faltam " + money(goal) + " em patch cords para ganhar R$ 100 de desconto.";
      } else {
        text.textContent = "Faltam " + money(remaining) + " em patch cords para chegar a R$ 1.000 e ganhar R$ 100 de desconto.";
      }
    });
  }

  var refreshTimer = 0;
  function refreshGoal() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      fetch(rootPath() + "cart.js", { credentials: "same-origin" })
        .then(function (response) { return response.json(); })
        .then(paintGoal)
        .catch(function () {});
    }, 120);
  }

  function copyCode(button) {
    var code = button.getAttribute("data-cpc-copy");
    if (!code) return;
    var done = function () {
      var original = button.getAttribute("data-label") || button.textContent;
      button.setAttribute("data-label", original);
      button.textContent = "Copiado";
      setTimeout(function () { button.textContent = original; }, 1400);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(done);
    } else {
      done();
    }
  }

  function guideEls() {
    return {
      root: document.querySelector("[data-cpc-guide]"),
      body: document.querySelector("[data-cpc-guide-body]")
    };
  }

  function openGuide() {
    var els = guideEls();
    if (!els.root) return;
    answers = {};
    step = 0;
    els.root.hidden = false;
    document.documentElement.style.overflow = "hidden";
    renderStep();
    var close = els.root.querySelector(".cpc-guide__close");
    if (close) close.focus();
  }

  function closeGuide() {
    var els = guideEls();
    if (!els.root) return;
    els.root.hidden = true;
    document.documentElement.style.overflow = "";
  }

  function activeQuestions() {
    return questions;
  }

  function bars(current, total) {
    var html = '<div class="cpc-quiz__steps" aria-hidden="true">';
    for (var i = 1; i <= total; i++) html += '<span class="' + (i <= current ? "is-on" : "") + '"></span>';
    return html + "</div>";
  }

  function renderStep() {
    var body = guideEls().body;
    if (!body) return;
    var list = activeQuestions();
    var current = list[step];
    if (!current) return;
    var choices = current.options.map(function (option) {
      return '<button type="button" class="cpc-quiz__choice" data-cpc-choice="' + option[0] + '"><strong>' + esc(option[1]) + "</strong><span>" + esc(option[2]) + "</span></button>";
    }).join("");
    body.innerHTML =
      bars(step + 1, list.length) +
      '<p class="cpc-quiz__count">Pergunta ' + (step + 1) + " de " + list.length + "</p>" +
      '<h3 class="cpc-quiz__question">' + esc(current.title) + "</h3>" +
      '<div class="cpc-quiz__choices">' + choices + "</div>" +
      (step > 0 ? '<button type="button" class="cpc-quiz__back" data-cpc-back>Voltar</button>' : "");
  }

  function recommendation(data) {
    var performance = data.velocidade === "mais" || data.uso === "jogo" || data.uso === "trabalho" || data.aparelhos === "muitos";
    var shielded = data.blindagem === "sim" || data.uso === "rack";
    var economia = data.prioridade === "economia" && !shielded;
    var meters = Number(data.tamanho);
    var uso = data.uso === "jogo"
      ? "Para jogar, o cabo segura a partida melhor do que o Wi-Fi."
      : data.uso === "trabalho"
        ? "Para o trabalho, o cabo deixa arquivo e videochamada mais firmes."
        : data.uso === "rack"
          ? "Para painel ou câmeras, o cabo fica no meio de vários equipamentos."
          : "Para a internet da casa, o cabo liga direto no roteador.";
    var gente = data.aparelhos === "muitos"
      ? " Ele aguenta cinco aparelhos ou mais ao mesmo tempo."
      : data.aparelhos === "alguns"
        ? " Ele serve quando três ou quatro aparelhos usam a rede juntos."
        : data.aparelhos === "dois"
          ? " Ele liga dois aparelhos."
          : " Ele liga um aparelho só.";
    if (shielded && performance) {
      return {
        name: "Cabo blindado para rede exigente",
        handle: "f-utp-cat6-cobre",
        meters: meters,
        why: uso + gente + " Como o caminho passa perto de energia e o uso pede mais, este cabo tem proteção extra e é Cat6."
      };
    }
    if (shielded) {
      return {
        name: "Cabo com proteção contra interferência",
        handle: "f-utp-cat5e-100-cobre",
        meters: meters,
        why: uso + " Como o caminho passa perto de fio de energia, este cabo tem proteção extra."
      };
    }
    if (performance && economia) {
      return {
        name: "Cat6, opção mais em conta",
        handle: "cat6-cca",
        meters: meters,
        why: uso + gente + " Acima do uso comum, o Cat6 é o indicado. Esta é a opção mais em conta."
      };
    }
    if (performance) {
      return {
        name: "Cat6 100% cobre",
        handle: "cat-6",
        meters: meters,
        why: uso + gente + (data.velocidade === "mais" ? " Acima de 1 giga, o Cat6 é o ideal." : " O fio é 100% cobre.")
      };
    }
    if (economia) {
      return {
        name: "Cat5e, opção mais em conta",
        handle: "cat5e-cca",
        meters: meters,
        why: uso + " Para essa velocidade, o Cat5e resolve. Esta é a opção mais em conta."
      };
    }
    return {
      name: "Cat5e 100% cobre",
      handle: "cat5e-100-cobre",
      meters: meters,
      why: uso + (data.velocidade === "100" ? " Até 100 mega, o Cat5e é o ideal." : data.velocidade === "500" ? " De 100 a 500 mega, o Cat5e é o ideal." : " De 500 mega a 1 giga, o Cat5e alcança essa velocidade.") + " O fio é 100% cobre."
    };
  }

  function metersFromTitle(title) {
    var text = String(title || "").toLowerCase().replace(",", ".");
    var centimeters = text.match(/(\d+(?:\.\d+)?)\s*cent/);
    if (centimeters) return parseFloat(centimeters[1]) / 100;
    var meters = text.match(/(\d+(?:\.\d+)?)\s*met/);
    if (meters) return parseFloat(meters[1]);
    return null;
  }

  function formatMeters(value) {
    if (value < 1) return Math.round(value * 100) + " cm";
    return String(value).replace(".", ",") + " m";
  }

  function pickProduct(products, meters) {
    var target = meters == null || !isFinite(meters) ? 2 : meters;
    var best = null;
    var bestGap = Infinity;
    products.forEach(function (product) {
      var variant = (product.variants || []).filter(function (item) { return item.available; })[0];
      if (!variant) return;
      var found = metersFromTitle(product.title);
      var gap = found == null ? 1000 : Math.abs(found - target);
      if (gap < bestGap) {
        bestGap = gap;
        best = { product: product, variant: variant, meters: found, exact: found != null && Math.abs(found - target) < 0.05 };
      }
    });
    return best;
  }

  function showStatus(message, handle) {
    var body = guideEls().body;
    if (!body) return;
    var total = activeQuestions().length;
    body.innerHTML =
      bars(total, total) +
      '<p class="cpc-quiz__count">Cabo indicado</p>' +
      '<h3 class="cpc-quiz__question">Um momento</h3>' +
      '<p class="cpc-quiz__why">' + esc(message) + "</p>" +
      '<div class="cpc-quiz__actions">' +
        (handle ? '<a class="cpc-casa__btn cpc-casa__btn--dark" href="/collections/' + esc(handle) + '">Ver a categoria</a>' : "") +
        '<button type="button" class="cpc-quiz__back" data-cpc-again>Responder de novo</button>' +
      "</div>";
  }

  function showResult(choice, picked) {
    var body = guideEls().body;
    var product = picked.product;
    var image = (product.images && product.images[0] && product.images[0].src) || "";
    if (image.indexOf("//") === 0) image = "https:" + image;
    var size = "";
    if (picked.meters != null) size = " Tamanho encontrado: " + formatMeters(picked.meters) + ".";
    if (choice.meters != null && !picked.exact) size += " Não havia essa medida disponível; este é o tamanho mais próximo.";
    var total = activeQuestions().length;
    body.innerHTML =
      bars(total, total) +
      '<p class="cpc-quiz__count">Cabo indicado</p>' +
      '<h3 class="cpc-quiz__question">' + esc(choice.name) + "</h3>" +
      '<p class="cpc-quiz__why">' + esc(choice.why + size) + "</p>" +
      '<a class="cpc-quiz__result" href="/products/' + esc(product.handle) + '">' +
        (image ? '<img src="' + esc(image) + '" alt="">' : "") +
        "<span><small>" + esc(choice.name) + "</small><strong>" + esc(product.title) + "</strong><em>" + esc(priceLabel(picked.variant.price)) + "</em></span></a>" +
      '<div class="cpc-quiz__actions">' +
        '<a class="cpc-casa__btn cpc-casa__btn--dark" href="/products/' + esc(product.handle) + '">Quero este cabo</a>' +
        '<a class="cpc-quiz__back" href="/collections/' + esc(choice.handle) + '">Ver outros tamanhos</a>' +
        '<button type="button" class="cpc-quiz__back" data-cpc-again>Responder de novo</button>' +
      "</div>";
  }

  function findCable() {
    var choice = recommendation(answers);
    showStatus("Procurando o cabo certo pra você...", "");
    fetch("/collections/" + choice.handle + "/products.json?limit=250")
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var picked = pickProduct(data.products || [], choice.meters);
        if (!picked) {
          showStatus("Não encontrei um cabo disponível nesta linha agora.", choice.handle);
          return;
        }
        showResult(choice, picked);
      })
      .catch(function () {
        showStatus("Não consegui buscar agora. Você pode abrir a categoria e escolher o tamanho.", choice.handle);
      });
  }

  function addVariant(id, button) {
    button.disabled = true;
    button.textContent = "Adicionando...";
    fetch(rootPath() + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: Number(id), quantity: 1, sections: "minicart" })
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) throw new Error(response.description || "fail");
        document.body.dispatchEvent(new CustomEvent("ajax:addToCart", { detail: { response: response } }));
        closeGuide();
        if (window.jQuery) {
          window.jQuery('.push_side[data-id="#js_cart_popup"]').trigger("click");
        }
        refreshGoal();
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = "Não entrou no carrinho. Abra o produto.";
      });
  }

  document.addEventListener("click", function (event) {
    var target = event.target.closest("[data-cpc-guide-open], [data-cpc-guide-close], [data-cpc-choice], [data-cpc-next], [data-cpc-back], [data-cpc-again], [data-cpc-add], [data-cpc-copy]");
    if (!target) return;
    if (target.hasAttribute("data-cpc-guide-open")) {
      event.preventDefault();
      openGuide();
    } else if (target.hasAttribute("data-cpc-guide-close")) {
      closeGuide();
    } else if (target.hasAttribute("data-cpc-choice")) {
      var list = activeQuestions();
      var current = list[step];
      if (!current) return;
      answers[current.key] = target.getAttribute("data-cpc-choice");
      list = activeQuestions();
      if (step >= list.length - 1) findCable();
      else {
        step += 1;
        renderStep();
      }
    } else if (target.hasAttribute("data-cpc-back")) {
      step = Math.max(0, step - 1);
      renderStep();
    } else if (target.hasAttribute("data-cpc-again")) {
      answers = {};
      step = 0;
      renderStep();
    } else if (target.hasAttribute("data-cpc-add")) {
      addVariant(target.getAttribute("data-cpc-add"), target);
    } else if (target.hasAttribute("data-cpc-copy")) {
      copyCode(target);
    }
  });

  function placeOfferOnBanner() {
    var host = document.querySelector(".cpc-banner-host");
    var deal = document.querySelector(".cpc-offer__deal");
    if (!host) return;
    if (host.querySelector(".cpc-on-banner")) {
      if (deal) deal.remove();
      return;
    }
    if (!deal) return;
    var bar = document.createElement("div");
    bar.className = "cpc-on-banner";
    var left = document.createElement("div");
    left.className = "cpc-on-banner__deal";
    var value = deal.querySelector(".cpc-offer__value");
    var detail = deal.querySelector(".cpc-offer__detail");
    if (value) left.appendChild(value);
    if (detail) left.appendChild(detail);
    bar.appendChild(left);
    var codeRow = deal.querySelector(".cpc-offer__code-row");
    if (codeRow) {
      codeRow.classList.add("cpc-on-banner__code");
      bar.appendChild(codeRow);
    }
    host.appendChild(bar);
    deal.remove();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", placeOfferOnBanner);
  } else {
    placeOfferOnBanner();
  }

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeGuide();
      document.querySelectorAll("[data-cpc-analysis]").forEach(function (dialog) {
        dialog.hidden = true;
      });
      document.documentElement.style.overflow = "";
    }
  });

  ["drawer:Minicart", "ajax:addToCart", "ajax:updateCart", "ajax:deleteCart"].forEach(function (name) {
    document.addEventListener(name, refreshGoal);
    document.body.addEventListener(name, refreshGoal);
  });

  if (window.jQuery) {
    window.jQuery(document.body).on("ajax:addToCart ajax:updateCart ajax:deleteCart update:miniCart drawer:Minicart", refreshGoal);
  }

  document.addEventListener("click", function (event) {
    var opener = event.target.closest("[data-cpc-analysis-open]");
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute("data-cpc-analysis-open"));
      if (!dialog) return;
      dialog.hidden = false;
      document.documentElement.style.overflow = "hidden";
      var closeButton = dialog.querySelector(".cpc-analysis-dialog__close");
      if (closeButton) closeButton.focus();
      return;
    }
    if (event.target.closest("[data-cpc-analysis-close]")) {
      var panel = event.target.closest("[data-cpc-analysis]");
      if (!panel) return;
      panel.hidden = true;
      document.documentElement.style.overflow = "";
    }
  });
})();

(function () {
  function plural(n, um, varios) {
    return n + " " + (n === "1" ? um : varios);
  }
  var textos = [
    [/^Customer Reviews$/, "Avaliações dos clientes"],
    [/^Be the first to write a review$/, "Seja o primeiro a avaliar"],
    [/^Write a review$/, "Escrever avaliação"],
    [/^Cancel review$/, "Cancelar"],
    [/^Based on (\d+) reviews?$/, function (m, n) { return "Com base em " + plural(n, "avaliação", "avaliações"); }],
    [/^(\d+) reviews?$/, function (m, n) { return plural(n, "avaliação", "avaliações"); }],
    [/^([\d.,]+) out of 5$/, "$1 de 5"],
    [/^out of 5$/, "de 5"],
    [/^No reviews$/, "Sem avaliações"],
    [/^Most Recent$/, "Mais recentes"],
    [/^Highest Rating$/, "Maior nota"],
    [/^Lowest Rating$/, "Menor nota"],
    [/^Only Pictures$/, "Só com fotos"],
    [/^Pictures First$/, "Fotos primeiro"],
    [/^Videos First$/, "Vídeos primeiro"],
    [/^Most Helpful$/, "Mais úteis"],
    [/^Submit Review$/, "Enviar avaliação"],
    [/^Rating$/, "Nota"],
    [/^Review Title$/, "Título"],
    [/^Review content$/, "Comentário"],
    [/^Display name$/, "Nome"],
    [/^Email address$/, "E-mail"],
    [/^Picture\/Video \(optional\)$/, "Foto ou vídeo (opcional)"],
    [/^Verified( Buyer)?$/, "Compra verificada"],
    [/^See all reviews$/, "Ver todas"],
    [/^Load More Reviews$/, "Ver mais avaliações"],
    [/^Read more$/, "Ler mais"],
    [/^Show more$/, "Ver mais"],
    [/^Reviews$/, "Avaliações"],
    [/^Was this review helpful\?$/, "Esta avaliação ajudou?"],
    [/^Give your review a title$/, "Dê um título"],
    [/^Start writing here\.\.\.$/, "Escreva aqui..."],
    [/^Your email address$/, "Seu e-mail"]
  ];

  function traduz(texto) {
    var limpo = texto.trim();
    if (!limpo) return null;
    for (var i = 0; i < textos.length; i++) {
      if (textos[i][0].test(limpo)) return texto.replace(limpo, limpo.replace(textos[i][0], textos[i][1]));
    }
    return null;
  }

  function traduzArea(area) {
    var walker = document.createTreeWalker(area, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var novo = traduz(node.nodeValue);
      if (novo !== null && novo !== node.nodeValue) node.nodeValue = novo;
    }
    area.querySelectorAll("input[placeholder], textarea[placeholder]").forEach(function (campo) {
      var novo = traduz(campo.placeholder);
      if (novo !== null) campo.placeholder = novo;
    });
  }

  var pendente = false;
  function agenda() {
    if (pendente) return;
    pendente = true;
    requestAnimationFrame(function () {
      pendente = false;
      document.querySelectorAll(".jdgm-widget, .jdgm-form-wrapper, .jdgm-rev-widg").forEach(traduzArea);
    });
  }

  agenda();
  new MutationObserver(function (lista) {
    for (var i = 0; i < lista.length; i++) {
      var alvo = lista[i].target;
      if (alvo.nodeType !== 1) alvo = alvo.parentElement;
      if (alvo && alvo.closest && alvo.closest("[class*='jdgm']")) return agenda();
      for (var j = 0; j < lista[i].addedNodes.length; j++) {
        var n = lista[i].addedNodes[j];
        if (n.nodeType === 1 && (/jdgm/.test(n.className) || n.querySelector && n.querySelector("[class*='jdgm']"))) return agenda();
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();

(function () {
  function azulado(cor) {
    var c = (cor.match(/\d+/g) || []).map(Number);
    return c.length >= 3 && c[2] > c[0] + 60 && c[2] > 150;
  }

  function ajusta(desc) {
    desc.querySelectorAll("*").forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.textAlign === "justify") el.style.setProperty("text-align", "left", "important");
      if (/^H[1-6]$/.test(el.tagName) && azulado(cs.color)) el.style.setProperty("color", "#ff8a00", "important");
    });
  }

  function roda() {
    document.querySelectorAll(".cpc-produto__desc").forEach(ajusta);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", roda);
  else roda();
  window.addEventListener("load", roda);
})();

(function () {
  function loopUpsell(grid) {
    if (!grid) return;
    var cards = Array.prototype.filter.call(grid.children, function (el) {
      return !!el.querySelector("img");
    });
    if (cards.length < 2) return;
    var widget = grid.closest(".cpc-produto__related") || grid.parentElement;
    if (widget) {
      widget.querySelectorAll("button").forEach(function (button) {
        if (button.classList.contains("cpc-upsell-arrow") || grid.contains(button)) return;
        var label = (button.getAttribute("aria-label") || button.textContent || "").trim().toLowerCase();
        if (!/^(previous|next|anterior|proximo|próximo)/.test(label) && label.length > 1) return;
        button.style.setProperty("display", "none", "important");
      });
    }
    if (grid.getAttribute("data-cpc-loop") === "1") return;
    grid.setAttribute("data-cpc-loop", "1");
    var host = grid.parentElement;
    if (host && !host.querySelector(".cpc-upsell-arrow")) {
      host.style.position = "relative";
      function arrow(direction) {
        var button = document.createElement("button");
        button.type = "button";
        button.className = "cpc-upsell-arrow cpc-upsell-arrow--" + direction;
        button.setAttribute("aria-label", direction === "next" ? "Próximos cabos" : "Cabos anteriores");
        button.innerHTML = "<span aria-hidden=\"true\">" + (direction === "next" ? "&#8250;" : "&#8249;") + "</span>";
        button.addEventListener("click", function () {
          var first = grid.firstElementChild;
          if (!first) return;
          var size = first.getBoundingClientRect().width + 10;
          var max = grid.scrollWidth - grid.clientWidth;
          if (direction === "next") {
            if (grid.scrollLeft >= max - 8) grid.scrollTo({ left: 0, behavior: "smooth" });
            else grid.scrollBy({ left: size, behavior: "smooth" });
          } else if (grid.scrollLeft <= 8) {
            grid.scrollTo({ left: grid.scrollWidth, behavior: "smooth" });
          } else {
            grid.scrollBy({ left: -size, behavior: "smooth" });
          }
        });
        host.appendChild(button);
      }
      arrow("prev");
      arrow("next");
    }
  }

  function scan() {
    document.querySelectorAll("[data-essential-upsell-element='add-to-cart-button']").forEach(function (button) {
      var grid = button.parentElement;
      while (grid && grid !== document.body) {
        var overflow = getComputedStyle(grid).overflowX;
        if ((overflow === "auto" || overflow === "scroll") && grid.scrollWidth > grid.clientWidth + 40) break;
        grid = grid.parentElement;
      }
      if (grid && grid !== document.body) loopUpsell(grid);
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", scan);
  else scan();
  window.addEventListener("load", function () { setTimeout(scan, 800); setTimeout(scan, 2000); });
})();
